import { InfoToolTip, RupeeIcon } from '@commenda/icons';
import { Input, Tooltip } from '@commenda/kakashi';
import { TEquityInfo } from '@commenda/types/src/incorporation/types';
import React from 'react';

type CompanyValuationInputProps = {
  equityInfo: Partial<TEquityInfo>;
  setEquityInfo: React.Dispatch<React.SetStateAction<TEquityInfo>>;
  shareCountPlaceholder: string;
};

const regexThatMatchesNumberWithCommas = /^[0-9][0-9,]*$/;

const CompanyValuationInputIN = ({
  equityInfo,
  setEquityInfo,
  shareCountPlaceholder,
}: CompanyValuationInputProps) => {
  return (
    <div className="flex flex-col gap-6 border-b pb-12">
      <div>
        <div className="flex items-center">
          <div className="flex items-center gap-2">
            <h3 className="text-base">Authorized Capital</h3>
            <Tooltip
              side="right"
              content="Authorized capital represents the maximum agreed-upon capital contribution by partners at formation, defining their financial commitments and ownership stake"
            >
              <InfoToolTip />
            </Tooltip>
          </div>
        </div>
        <span className="text-sm text-neutral-2">
          This is the valuation for the company.
        </span>
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-6">
          <div className="flex flex-col gap-1">
            <Input
              type="text"
              maxLength={15}
              placeholder={shareCountPlaceholder}
              value={equityInfo?.shareCount?.toLocaleString() || ''}
              leftEl={RupeeIcon}
              onChange={(e) => {
                const newValue = e.currentTarget.value;
                if (!newValue) {
                  setEquityInfo((current) => ({
                    ...current,
                    shareCount: undefined,
                  }));
                } else if (regexThatMatchesNumberWithCommas.test(newValue)) {
                  setEquityInfo((current) => ({
                    ...current,
                    shareCount: parseInt(newValue.replaceAll(',', ''), 10),
                  }));
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyValuationInputIN;
